import i18next from 'i18next'
import {
  CategoriesFilter,
  filteredUrl,
  TopFilters,
} from '../../filters/filtersUtils'

export async function getComponentTeasers(
  pageSize = 6,
  page = 0,
  filters?: { categoriesFilter: CategoriesFilter; topFilters: TopFilters }
): Promise<any> {
  const url = filteredUrl('/api/v1/components/filter')({
    categoriesFilter: filters?.categoriesFilter, 
    topFilters: filters?.topFilters,
    page: page, 
    pageSize: pageSize,
    language: i18next.language,
    includePyramid: true
  });  
  
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const response = await fetch(url,
    { method: 'get', headers: headers }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

export async function getComponentsCount(filters?: {
  categoriesFilter: CategoriesFilter
  topFilters: TopFilters
}): Promise<any> {
  const url = filteredUrl('/api/v1/components/filter/count')({
    categoriesFilter: filters?.categoriesFilter, 
    topFilters: filters?.topFilters,
    language: i18next.language,
    includePyramid: true
  });  

  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const response = await fetch(
    url,
    { method: 'get', headers: headers }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}
